// Production Endpoint
// export const endpoint = `https://api.myreky.com`;
// Staging Endpoint
// export const endpoint = `https://staging.myreky.com`;
//
// 1. This will be the 'staging' endpoint when run in development mode as set-up in .env.
// 2. Netlify also over rides this to always use the 'staging' endpoint.
// 3. When building for production it will then contain the 'prod' endpoint.
export const endpoint = process.env.REACT_APP_API_ENDPOINT;
